import Authorization from '@/lib/Authorization';

export default {
  /**
   * Responsible for routes where there is no auth required
   */
  guest(to, from, next) {
    next(!Authorization.getToken());
  },

  /**
   * Ensures that the user is logged in, otherwise redirects to login
   */
  auth(to, from, next) {
    next(Authorization.getToken() ? true : {
      path: '/login',
      query: {
        redirect: to.name,
      },
    });
  },
};
